/* Markup for the "take another design" offer (personalizer-bag-designs.js).

   Built once, then only classes, text and the swatch row change — a rebuild
   under a tapping finger loses the tap. Kept apart from the state module so
   the persuasion and the arithmetic never tangle. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Only a real hex reaches a style attribute — palette data is not trusted. */
  function hex(h) {
    return /^#[0-9a-fA-F]{3,8}$/.test(String(h)) ? String(h) : '#cccccc';
  }

  function swatches(v) {
    if (!v.needsColour || !v.palettes.length) return '';
    var dots = v.palettes.map(function (p) {
      var sel = v.color === p.name;
      var white = String(p.hex).toLowerCase() === '#ffffff';
      return '<button type="button" role="radio" aria-checked="' + (sel ? 'true' : 'false') + '"'
        + ' class="personalizer__dot' + (sel ? ' personalizer__dot--sel' : '') + '"'
        + ' data-pzd-color="' + esc(p.name) + '" title="' + esc(p.name) + '"'
        + ' aria-label="' + esc(p.name) + ' bag"'
        + ' style="background:' + hex(p.hex) + (white ? ';border-color:#c9c9c9' : '') + '"></button>';
    }).join('');
    return '<div class="personalizer__pzd-colors">'
      + '<div class="personalizer__bl">Bag colour'
      + '<span class="personalizer__bl-echo" aria-live="polite">' + esc(v.color || 'tap a colour') + '</span></div>'
      + '<div class="personalizer__sw" role="radiogroup" aria-label="Colour for the ' + esc(v.title) + '">'
      + dots + '</div></div>';
  }

  function card(v, money) {
    return '<div class="personalizer__pzd' + (v.on ? ' personalizer__pzd--sel' : '') + '"'
      + ' data-pzd-card="' + esc(v.handle) + '">'
      + '<button type="button" class="personalizer__pzd-hit" data-pzd-pick="' + esc(v.handle) + '"'
      + ' aria-pressed="' + (v.on ? 'true' : 'false') + '">'
      + (v.image
        ? '<img class="personalizer__pzd-img" src="' + esc(v.image) + '" alt="" loading="lazy">'
        : '<span class="personalizer__pzd-img" aria-hidden="true"></span>')
      + '<span class="personalizer__pzd-body">'
      + '<span class="personalizer__pzd-nm">' + esc(v.title) + '</span>'
      // what the design actually is — the same line the collection card shows
      + (v.tagline ? '<span class="personalizer__pzd-tag">' + esc(v.tagline) + '</span>' : '')
      + '<span class="personalizer__pzd-pr">' + esc(money(v.nowCents))
      + '<s>' + esc(money(v.fullCents)) + '</s></span>'
      + '</span>'
      + '<span class="personalizer__pzd-tick" aria-hidden="true"></span>'
      + '</button>'
      + (v.on ? swatches(v) : '')
      + '</div>';
  }

  function list(offer, views, money) {
    return '<div class="personalizer__qrow">'
      + '<div class="personalizer__q">' + esc(offer.heading) + '</div></div>'
      + (offer.sub ? '<p class="personalizer__subhint">' + esc(offer.sub) + '</p>' : '')
      + '<div class="personalizer__pzd-list">'
      + views.map(function (v) { return card(v, money); }).join('')
      + '</div>'
      + (offer.note
        ? '<p class="personalizer__samepet-note"><span aria-hidden="true">✓</span>'
          + '<span>' + esc(offer.note) + '</span></p>'
        : '');
  }

  /* Selected state, price text and the swatch row, without touching the rest. */
  function sync(mount, views, money) {
    views.forEach(function (v) {
      var el = mount.querySelector('[data-pzd-card="' + v.handle + '"]');
      if (!el) return;
      el.classList.toggle('personalizer__pzd--sel', v.on);
      var hit = el.querySelector('[data-pzd-pick]');
      if (hit) hit.setAttribute('aria-pressed', v.on ? 'true' : 'false');
      var pr = el.querySelector('.personalizer__pzd-pr');
      if (pr) pr.innerHTML = esc(money(v.nowCents)) + '<s>' + esc(money(v.fullCents)) + '</s>';
      var colors = el.querySelector('.personalizer__pzd-colors');
      if (v.on && !colors) el.insertAdjacentHTML('beforeend', swatches(v));
      else if (!v.on && colors) colors.remove();
      else if (v.on && colors) {
        var echo = colors.querySelector('.personalizer__bl-echo');
        if (echo) echo.textContent = v.color || 'tap a colour';
        colors.querySelectorAll('[data-pzd-color]').forEach(function (d) {
          var sel = d.getAttribute('data-pzd-color') === v.color;
          d.classList.toggle('personalizer__dot--sel', sel);
          d.setAttribute('aria-checked', sel ? 'true' : 'false');
        });
      }
    });
  }

  window.PersonalizerBagDesignsRender = { list: list, sync: sync };
})();
